module.exports = __webpack_public_path__ + "static/clarinet_cn-853591172154c13a7c48327f952a908a.pdf";